// Derivación — algoritmo original, extraído sin modificar de js/derivacion.js.
// Verificado contra tools/caracterizacion/golden.json.

export function validar({ sucursalOrigen, sucursalDestino }) {
  if (String(sucursalOrigen) === String(sucursalDestino)) {
    return 'La sucursal de origen y la de destino no pueden ser la misma';
  }
  return null;
}

export function calcular(
  { tipoFactura, puesto, nroFactura, sucursalOrigen, sucursalDestino },
  hoy = new Date(),
) {
  const mes = hoy.getMonth() + 1;
  const dia = hoy.getDate();

  const Factura_Puesto = parseInt(puesto, 10);
  const Factura_Numero = parseInt(nroFactura, 10);
  const sucOrigen = parseInt(sucursalOrigen, 10);
  const sucDestino = parseInt(sucursalDestino, 10);

  let Resultado = (tipoFactura == 'FCB' ? 5794 : 3061);

  let tmp = (Math.pow(dia, 5) * ((Factura_Puesto * 476) % 1000));
  Resultado = Resultado + tmp;

  tmp = (Math.pow(mes, 4) * ((Factura_Numero * (Factura_Numero % 2 == 0 ? 743 : 264)) % 1000));
  Resultado = Resultado + tmp;

  tmp = (Math.pow(sucOrigen, 7) * Math.pow(sucDestino, 3));
  Resultado = Resultado + tmp;

  Resultado = Resultado % 10000;

  return {
    codigo: Resultado,
    detalle: {
      tipoFactura,
      puesto: Factura_Puesto,
      nroFactura: Factura_Numero,
      sucursalOrigenId: sucOrigen,
      sucursalDestinoId: sucDestino,
    },
  };
}
